<!DOCTYPE html>
<ion-content class="age-verification">
  <div class="bg-div">
    <div class="header">
      <h2>Age Verification</h2>
      <p>
        We need to check that you are eligible to play in lotteries - over 18+
        only
      </p>
    </div>
    <div class="form-wrapper">
      <ion-grid>
        <ion-row>
          <ion-col>
            <h3 class="form-label">1.Enter Date of birth</h3>
          </ion-col>
          <ion-col>
            <div class="dob-card">
              <form [formGroup]="ageVerifyForm">
                <label> Date of birth </label>
                <!-- <ion-input
                placeholder="dd/mm/yyyy"
                id="date"
                formControlName="dateOfBirth"
                (blur)="validateDate($event)"
              ></ion-input> -->
              <ion-input placeholder="mm/dd/yyyy" id="date" formControlName="dateOfBirth"></ion-input>
              <ion-modal #popover trigger="date" class="date">
                <ng-template>
                  <!-- use ion-date time to select date -->
                  <ion-datetime mode="ios" (ionChange)="onDateChange($event)" presentation="date" [preferWheel]="true"
                    [value]="defaultDateOfBirth" displayFormat="M/D/YYYY" pickerFormat="MMM D YYYY"
                  [locale]="selectedLanguage"></ion-datetime>
                </ng-template>
              </ion-modal>
            </form>
            @if ( this.checkInput === true  && this.ageVerifyForm && ageVerifyForm?.get('dateOfBirth')?.errors?.futureInvalidDate != true) {
              <div class="checkDate"
                >
                <img class="check-circle" src="../../../assets/icon/check-circle.svg" alt="ok" />
              </div>
            }
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        @if (
          ageVerifyForm.get('dateOfBirth').touched &&
          ageVerifyForm?.get('dateOfBirth')?.errors?.futureInvalidDate) {
          <div class="errorContainer two-line-error-message">
            <ion-icon name="warning" class="icon"></ion-icon>
            <span class="text">{{'signup.valid_age' | translate}}</span>
          </div>
        }
      </ion-row>
    </ion-grid>
    <ion-grid [hidden]="hideVerificationMethod">
      <ion-row>
        <ion-col>
          <h3 class="form-label">2.Select a verification method</h3>
          <ion-row class="wrap1 expansion-wraaper">
            <ion-col size="12">
              <h1 (click)="showDescription('wrap1')">
                <span [class]="!iswrap1Expanded ? 'icon-empty' : 'icon-fill'"></span>
                <span class="title" [class]="!iswrap1Expanded ? 'text-disabled' : ''">Express - instant</span>
              </h1>
              <p [class]="!iswrap1Expanded ? 'text-disabled' : ''">
                Use your DEBIT CARD to verify your age and get your FREE
                tickets immediately. Your debit card will NOT be charged.
              </p>
            </ion-col>
            <div>
              @if ((iswrap1Expanded==true) && (iswrap1Expanded==true)) {
                <ion-col size="12" class="openState-wrapper"
                ></ion-col>
              }
              <div [ngClass]="isPaymentDone ? 'visibleData' : 'hiddenData'" style="visibility: hidden">
                <iframe style="border: 0; width: 100%; height: 100%; padding: 1vh" #iframe id="myCustomIframe1"
                  name="myCustomIframe1" (load)="load()"
                  sandbox="allow-forms allow-modals allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation">
                </iframe>
              </div>
              @if (!isPaymentDone) {
                <div [ngClass]="loaded ? 'visibleData' : 'hiddenData'">
                  <form action="{{ origin + '/r' }}" class="paymentWidgets" data-brands="VISA MASTER"></form>
                </div>
              }
              @if (loading) {
                <div style="position: absolute; width: 92%; text-align: center">
                  <ion-spinner name="lines-small" diameter="40" style="color: green; margin-top: 4vh">
                  </ion-spinner>
                </div>
              }
            </div>
          </ion-row>
          <ion-row class="wrap1 expansion-wraaper">
            <ion-col>
              <h1 (click)="showDescription('wrap2')">
                <span [class]="!iswrap2Expanded ? 'icon-empty' : 'icon-fill'"></span>
                <span class="title" [class]="!iswrap2Expanded ? 'text-disabled' : ''">Standard - 5 day</span>
              </h1>
              <p [class]="!iswrap2Expanded ? 'text-disabled' : ''">
                Use a copy of my passport or driver's license as proof of my
                age. I understand that it might take 5 days to be confirmed.
              </p>
              <div class="btn-wrapper">
                <ion-button aria-label="submit" expand="block" class="upload-btn browse-files file-input"
                  [disabled]="((iswrap2Expanded==true) && (iswrap2Expanded==true))? false:true">
                  <input type="file" id="file" name="file" (change)="onFileSelected($event)" />
                  @if (!selectedFile) {
                    <label for="file">Upload Image</label>
                  }
                  @if (selectedFile) {
                    <label for="file" [innerHTML]="selectedFile.name"></label>
                  }
                </ion-button>
                <ion-button aria-label="submit" expand="block" class (click)="switchExpressDialog()"
                  [disabled]="((iswrap2Expanded==true) && (iswrap2Expanded==true))? false:true" type="submit">Verify
                my age</ion-button>
              </div>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
</ion-content>
